/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Request, Response, NextFunction } from "express";
import type { ParsedQs } from "qs";

export type KazooRequestHandler =
  | ((
      req: Request<any, any, any, ParsedQs, Record<string, any>>,
      res: Response,
      next: NextFunction
    ) => Promise<any>)
  | ((
      req: Request<any, any, any, ParsedQs, Record<string, any>>,
      res: Response,
      next: NextFunction
    ) => Promise<any>);
